var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrogIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24AE5F"
    },
    d: "M445.096,164.829c19.156-14.504,31.594-37.429,31.594-63.311c0-43.873-35.575-79.448-79.448-79.448   c-43.882,0-79.448,35.575-79.448,79.448c0,1.951,0.15,3.866,0.291,5.782c-19.88-3.761-40.669-5.782-62.084-5.782   s-42.205,2.022-62.084,5.782c0.132-1.916,0.291-3.831,0.291-5.782c0-43.873-35.575-79.448-79.448-79.448   c-43.882,0-79.448,35.575-79.448,79.448c0,25.882,12.429,48.808,31.585,63.311C25.353,199.353,0,245.292,0,295.724   c0,107.255,114.609,194.207,256,194.207c141.383,0,256-86.952,256-194.207C512,245.292,486.647,199.353,445.096,164.829"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C8446"
    },
    d: "M255.997,331.035c-47.104,0-89.556-24.744-113.567-66.198c-2.445-4.22-1.006-9.613,3.213-12.058   c4.237-2.445,9.613-1.006,12.058,3.213c20.824,35.937,57.565,57.388,98.295,57.388s77.471-21.451,98.295-57.388   c2.445-4.22,7.821-5.658,12.058-3.213c4.22,2.445,5.659,7.839,3.213,12.058C345.553,306.292,303.101,331.035,255.997,331.035"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M150.066,110.346c0,14.627-11.855,26.483-26.483,26.483s-26.483-11.855-26.483-26.483    s11.855-26.483,26.483-26.483S150.066,95.718,150.066,110.346"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M414.894,110.346c0,14.627-11.855,26.483-26.483,26.483c-14.627,0-26.483-11.855-26.483-26.483    s11.855-26.483,26.483-26.483C403.038,83.863,414.894,95.718,414.894,110.346"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C8446"
    },
    d: "M88.273,384.001c0-24.373-19.765-44.138-44.138-44.138c-12.818,0-24.267,5.553-32.327,14.283    c10.761,25.918,28.522,49.452,51.553,69.411C78.06,416.398,88.273,401.453,88.273,384.001"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C8446"
    },
    d: "M397.239,392.828c0,14.627-11.855,26.483-26.483,26.483c-14.627,0-26.483-11.855-26.483-26.483    s11.855-26.483,26.483-26.483C385.383,366.346,397.239,378.201,397.239,392.828"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C8446"
    },
    d: "M61.79,251.587c0,14.627-11.855,26.483-26.483,26.483S8.825,266.214,8.825,251.587    s11.855-26.483,26.483-26.483S61.79,236.96,61.79,251.587"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C8446"
    },
    d: "M509.833,270.727c-4.864-28.672-17.929-55.384-37.411-78.733    c-17.938,5.606-31.047,22.157-31.047,41.94c0,24.373,19.765,44.138,44.138,44.138    C494.508,278.072,502.859,275.344,509.833,270.727"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrogIcon);
export default __webpack_public_path__ + "static/media/FrogIcon.6af8169c455ce06b5ba8fc592aab16a3.svg";
export { ForwardRef as ReactComponent };